import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';

import { fetchSignatories } from '@/services/tenant/share-credit-services';
import { RootState } from '@/store';

export interface SignatoriesState {
  signatories: any[];
  loading: boolean;
  error: string | null;
}

const initialState: SignatoriesState = {
  signatories: [],
  loading: false,
  error: null,
};

export const fetchSignatoriesThunk = createAsyncThunk(
  'signatories/fetchSignatories',
  async (securityId: number | string, { rejectWithValue }) => {
    try {
      const data = await fetchSignatories(securityId);
      return data;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data?.message || 'Failed to fetch signatories'
      );
    }
  }
);

const signatoriesSlice = createSlice({
  name: 'signatories',
  initialState,
  reducers: {
    clearSignatories(state) {
      state.signatories = [];
      state.error = null;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(fetchSignatoriesThunk.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        fetchSignatoriesThunk.fulfilled,
        (state, action: PayloadAction<any[]>) => {
          state.loading = false;
          state.signatories = action.payload ?? [];
        }
      )
      .addCase(fetchSignatoriesThunk.rejected, (state, action: any) => {
        state.loading = false;
        state.error = action.payload || 'Failed to fetch signatories';
      });
  },
});

export const selectSignatories = (state: RootState) =>
  state.tenant.signatories.signatories;

export const { clearSignatories } = signatoriesSlice.actions;

export default signatoriesSlice.reducer;
